import { css } from '@emotion/core';
import { variables } from '@domain-group/fe-brary';
var colour = variables.colour,
  font = variables.font;
export var filter = /*#__PURE__*/css("padding:0 0 23px;margin:0 0 10px;border-bottom:1px solid ", colour.neutral200, ";&:last-child{border:0;}");
export var title = /*#__PURE__*/css("display:block;font-family:", font.bodyFontFamily, ";font-size:", font.baseFontSize, ";line-height:", font.baseLineHeight, ";font-weight:", font.headingFontWeight, ";color:", colour.neutral700, ";margin-bottom:11px;");